<!--suppress JSUnresolvedReference, VueDataFunction, TypeScriptUMDGlobal -->
<template>

    <div class="suggestive-search h-full">
        <div class="input-form mb-[50vh] md:mb-0">
            <form :action="formActionSearch" method="GET" @submit="doSubmit">
                <label class="w-full text-center text-white text-fh3 sr-only" for="search">Search</label>
                <div class="flex flex-nowrap justify-between gap-1 content-center items-center w-full">
                    <span class="border-b border-petrol w-full ">
                        <input type="text" id="Search" name="Search" v-on:keyup="updateQuery" v-model="holdingSearchTerm"
                               class="border-0 h-[40px] px-1 text-white bg-dark-teal placeholder:text-white/90 w-full"
                               placeholder="What are you looking for?"/>
                    </span>
                    <button v-if="holdingSearchTerm" class="border-0 border-none m-0 p-0 btn border-dark-blue -ml-[50px]">
                        <img :src="searchIcon" alt="Search icon" class="border-0 m-0 p-0 w-[40px] h-[40px]">
                    </button>
                    <a v-else :href="resultsPageClean" class="shrink-0 w-[40px]">
                        <img :src="searchIcon" alt="Search icon" class="border-0 m-0 p-0 w-[40px] h-[40px]">
                        <span class="sr-only">Search</span>
                    </a>
                </div>

            </form>
        </div>


        <div class="absolute w-[calc(100%-85px)] md:w-1/2 text-center results top-[40%] left-[70px] md:right-0 h-[60%] overflow-y-auto
                md:top-[7.5rem] md:left-[calc(50%+23px)] md:w-[calc(50%-55px)] md:h-[calc(100%-7.5rem)] md:overflow-y-auto
                ">
            <div v-if="hasResults">
                <p  class="w-full text-left tracking-wide font-bold text-white uppercase mb-4">
                    Suggested Results
                </p>
                <div v-for="term in readPages"
                     class="cursor-pointer overflow-hidden p-4 bg-pale-olive rounded-[0.85rem] mb-[1.25rem]"
                     v-on:click.prevent="goTo(term.absoluteLink)">
                    <p class="flex-1 text-fh5 text-dark-blue  text-left mb-4">
                        <a :href="term.absoluteLink" class="leading-tight font-bold text-dark-teal text-xl">
                            {{ term.title }}
                        </a>
                    </p>
                    <div class="text-left line-clamp-[3] mb-4">{{ term.summary }}</div>
                    <p class="hidden md:block flex-1 text-left">
                        <a :href="term.absoluteLink" class="uppercase leading-tight font-bold text-dark-teal">
                            Read More
                        </a>
                    </p>
                </div>
                <div class="cursor-pointer overflow-hidden ">
                    <p class="flex-1 text-center pb-2rem">
                        <a class="btn-dark" :href="formActionSearch">
                            View All Results
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="$apollo.queries.readPages.loading">
                Loading...
            </div>
        </div>


    </div>

</template>

<script>
// noinspection ES6UnusedImports
import {debounce} from "lodash";
import gql from 'graphql-tag';

export default {
    name: "SuggestiveSearch",
    data: {
        holdingSearchTerm: '',
        searchTerm: '',
        limit: 2,
        hasResults: false
    },
    computed: {
        formActionSearch: function () {
            return decodeURIComponent(this.formAction) + '?Search=' + this.searchTerm + '&action_results=Go';
        },
        resultsPageClean: function () {
            return decodeURIComponent(this.formAction.replace('SearchForm/', ''));
        }
    },
    mounted: function () {
        this.setLimit();
        window.addEventListener('resize', this.setLimit);
    },
    props: {
        formAction: {
            type: String,
            required: false
        },
        searchIcon: {
            type: String,
            required: false
        }
    },
    methods: {
        setLimit: function () {
            if (window.matchMedia("(min-width: 768px)").matches) {
                this.limit = 3;
            } else {
                this.limit = 2;
            }
        },
        goTo: function (link) {
            if (link) {
                window.location.href = link;
            }
        },
        doSubmit: function () {
            window.location.href = this.formActionSearch;
        },
        updateQuery: _.debounce(
            function () {
                this.searchTerm = (this.holdingSearchTerm.length > 2) ? this.holdingSearchTerm : '';
            }, 700)
    },
    apollo: {
        readPages: {
            query: gql`
                query readPages($searchTerm: String!, $limit: Int) {
                    readPages(filter: {allContent: { contains: $searchTerm } }, limit: $limit) {
                        nodes {
                          title
                          summary
                          metaDescription
                          absoluteLink
                        }
                    }
                }
            `,
            variables() {
                return {
                    searchTerm: this.searchTerm,
                    limit: this.limit
                }
            },
            skip() {
                return this.searchTerm.length <= 2;
            },
            update: data => data.readPages.nodes,
            result({data}) {
                const hasResults = data && data.readPages && data.readPages.nodes && data.readPages.nodes.length > 0;
                this.hasResults = hasResults;
                this.$emit('search-results-status', hasResults);
            }
        }
    },
}
</script>

<style scoped>

</style>
